import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getTickets() {
    return axios.get(API_URL+'/v1/support/')
  }

export function getTicketsID(id:any) {
    return axios.get(API_URL+'/v1/support/'+id)
  }